var render = function render(_c,_vm){return _c('div',[_c('price-format',{attrs:{"format":_vm.props.row.price_format,"value":_vm.props.row['price']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }